import React, { useState } from 'react';
import '../FAQSection.css';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    id: 1,
    question: "Jakie sa wasze kwalifikacje jako nauczyciele matematyki?",
    answer: "Wszyscy nasi nauczyciele maja wyksztalcenie matematyczne (magisterskie lub wyzsze) oraz wieloletnie doswiadczenie w nauczaniu. Dodatkowo przechodza specjalistyczne szkolenia z naszej autorskiej metodologii nauczania."
  },
  {
    id: 2,
    question: "Ile kosztuja zajecia i czy to sie oplaca?",
    answer: "Zajecia grupowe kosztuja 65 PLN za 60 minut, zajecia indywidualne 150 PLN za 60 minut. To mniej niz korepetycje prywatne, a efekty sa lepsze dzieki sprawdzonej metodologii. Pierwsza lekcja jest zawsze GRATIS - bez zadnych zobowiazan!"
  },
  {
    id: 3,
    question: "Jak szybko moje dziecko zacznie osiagac lepsze wyniki?",
    answer: "Wiekszosc uczniow poprawia oceny juz po 2-3 tygodniach regularnych zajec. Widzimy to w naszych statystykach - srednia poprawa to 1,3 stopnia w ciagu pierwszego miesiaca. Najszybsze efekty osiagaja uczniowie uczestniczacy na zajeciach 2-3 razy w tygodniu."
  },
  {
    id: 4,
    question: "Czy moje dziecko nadrobi zaleglosci, jesli ma slabe podstawy?",
    answer: "Absolutnie! Specjalizujemy sie w nadrabianiu zaleglosci. Nasz program 'Fundament Plus' jest zaprojektowany wlasnie dla uczniow z lukami w podstawach. 89% uczniow z tego programu osiaga oceny dobre lub bardzo dobre w ciagu semestru."
  },
  {
    id: 5,
    question: "Co jesli matematyka to najwiekszy koszmar mojego dziecka?",
    answer: "Rozumiemy! Nasi nauczyciele sa ekspertami w pracy z uczniami, ktorzy boja sie matematyki. Uzywamy metody 'malych krokow' i pozytywnego wzmacniania. Po miesiacu 94% uczniow deklaruje, ze matematyka przestala byc dla nich trudna."
  },
  {
    id: 6,
    question: "Jak przygotowujecie do matury z matematyki?",
    answer: "Nasz program maturalny obejmuje wszystkie typy zadan, techniki rozwiazywania pod presja czasu i symulacje egzaminow. Uczniowie zyskuja pewnosc siebie i wiedze potrzebna do zdania matury na poziomie podstawowym i rozszerzonym."
  },
  {
    id: 7,
    question: "Czy zajecia sa dostosowane do programu szkolnego?",
    answer: "Tak! Nasze materialy sa w 100% zgodne z aktualna podstawa programowa. Sledzimy zmiany w systemie edukacji i na biezaco aktualizujemy nasze programy nauczania, aby wspierac uczniow w szkole."
  },
  {
    id: 8,
    question: "Ile uczniow jest w grupie i czy to wplywa na jakosc nauczania?",
    answer: "Nasze grupy licza maksymalnie 6 uczniow, co pozwala na indywidualne podejscie do kazdego z nich. Taki rozmiar grupy zapewnia optymalne warunki do nauki - kazdy uczen otrzymuje uwage nauczyciela i moze aktywnie uczestniczyc w zajeciach."
  },
  {
    id: 9,
    question: "Co jesli zajecia online nie sprawdza sie dla mojego dziecka?",
    answer: "Bez problemu! Mozesz zmienic na zajecia stacjonarne w kazdej chwili lub laczyc oba rodzaje. Mamy tez hybrydowe zajecia, gdzie uczen ma wybor formy w zaleznosci od potrzeb. Pierwsza lekcja testowa pokaze, co bedzie najlepsze."
  },
  {
    id: 10,
    question: "Jakie materialy edukacyjne otrzyma moje dziecko?",
    answer: "Kazdy uczen otrzymuje dostep do naszej platformy edukacyjnej z zadaniami, filmami instruktazowymi i testami. Dodatkowo dostarczamy autorskie skrypty i zeszyty cwiczen dostosowane do poziomu ucznia."
  }
];

const AuditedFAQSection: React.FC = () => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (id: number) => {
    setOpenItems(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2>Masz watpliwosci? To normalne!</h2>
          <p>Oto odpowiedzi na pytania, ktore zadaje 90% rodzicow przed zapisaniem dziecka na kurs. Przekonaj sie, dlaczego warto wybrac Sigma Study School.</p>
        </div>

        <div className="faq-content">
          {faqData.map((item) => (
            <div key={item.id} className={`faq-item ${openItems.includes(item.id) ? 'open' : ''}`}>
              <button
                className="faq-question"
                onClick={() => toggleItem(item.id)}
                aria-expanded={openItems.includes(item.id)}
              >
                <span>{item.question}</span>
                <span className="faq-icon">
                  {openItems.includes(item.id) ? '-' : '+'}
                </span>
              </button>

              {openItems.includes(item.id) && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-contact">
          <h3>Gotowy na pierwszy krok?</h3>
          <p>Przestan martwic sie ocenami z matematyki! Juz za miesiac Twoje dziecko moze miec lepsze oceny. Pierwsza lekcja jest GRATIS - nie masz nic do stracenia!</p>
          <div className="contact-buttons">
            <button className="contact-btn primary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Rozpocznij za darmo
            </button>
            <a href="tel:+48532533220" className="contact-btn secondary">
              Zadzwon: +48 532 533 220
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedFAQSection;
